import { useQuery } from '@tanstack/react-query'
import apis from '../../../../apis'
import { axiosGet } from '../../../../axiosHelper'

const fetchLessonInfo = async (lessonId: number) => {
  const response = await axiosGet(apis.lessons.review.lessonInfo(lessonId))
  return response.lesson
}

export const useLessonInfo = (lessonId: number, queryOptions?: Record<string, any>) => {
  return useQuery({
    queryKey: ['lessonInfo', lessonId],
    queryFn: () => fetchLessonInfo(lessonId),
    enabled: !!lessonId,
    ...queryOptions,
  })
}

const fetchScript = async (lessonId) => {
  const response = await axiosGet(apis.lessons.review.script(lessonId))
  return response
}

export const useLessonScript = (lessonId: number, queryOptions?: Record<string, any>) => {
  return useQuery({
    queryKey: ['script', lessonId],
    queryFn: () => fetchScript(lessonId),
    enabled: !!lessonId,
    ...queryOptions,
  })
}
